<template>
  <div id="nav">
    <!-- <ul id="header_nav" class="header_nav container yu_fc">
      <li class="header_nav_class">
        <span v-if="path === '/'">商品分类</span>
      </li>
      <li class="header_nav_li" :class="path === '/' ? 'active' : ''">
        <router-link class="link" to="/">首页</router-link>
      </li>
      <li class="header_nav_li">
        <a class="link" href="javascript:void(0)" @click="goClassifyIndex('康养馆')">康养馆</a>
      </li>
      <li class="header_nav_li">
        <a class="link" href="javascript:void(0)" @click="goClassifyIndex('地域精品')">地域精品</a>
      </li>
      <li class="header_nav_li">
        <a class="link" href="javascript:void(0)" @click="goClassifyIndex('名企精品')">名企精品</a>
      </li>
      <li class="header_nav_li">
        <a class="link" href="javascript:void(0)" @click="goClassifyIndex('9.9包邮')">9.9包邮</a>
      </li>
      <li class="header_nav_li">
        <a class="link" href="javascript:void(0)" @click="goClassifyIndex('搜精品自营')">搜精品自营</a>
      </li>
    </ul> -->
  </div>
</template>

<script>
export default {
  name: "sjpNav",
  data() {
    return {
      ids: "",
      path: "",
      navArr: [],
      title: ""
    };
  },
  created() {
    // this.getNav();
    this.path = this.$route.path;
    this.ids = localStorage.getItem("classId");
  },
  methods: {
    goClassifyIndex(name){
      if(this.title == name){

      }else{
        this.title = name
        let router = this.$router.resolve({
          path: "/classifyIndex",
          query: {
            name
          }
        });
        window.open(router.href, "_blank");
      }
    }
  },
  watch:{
    $route(to,from){
      // console.log(to,from);
      this.path = this.$route.path;
      console.log(to.name != "classify" && to.name != "goodsDetail")
      console.log(from.name == "classify" || from.name == "goodsDetail")
      if((to.name != "classify" && to.name != "goodsDetail") && (from.name == "classify" || from.name == "goodsDetail")){
        localStorage.setItem("classId", "");
      }
      this.ids = localStorage.getItem("classId");
    }
  }
};
</script>

<style scoped>
#nav {
  width: 100%;
  height: 0px;
  box-shadow: 0px 4px 4px 0px rgba(153,153,153,0.1);
  background: #fff;
  position: relative;
  z-index: 9;
}
.header_nav_class{
  float: left;
  width:160px;
  height:40px;
  margin-right: 10px;
}
.header_nav_class span{
  display: block;
  width:160px;
  height:40px;
  line-height: 40px;
  text-align: center;
  font-size:16px;
  font-weight:400;
  color:rgba(255,255,255,1);
  background:rgba(180,39,45,1);
}
.header_nav_li{
  float: left;
  padding: 0 30px;
  /* width: 125px; */
}
.header_nav_li .link {
  /* float: left; */
  display: inline-block;
  vertical-align: top;
  font-size:16px;
  font-weight:bold;
  color:rgba(51,51,51,1);
  line-height: 40px;
  position: relative;
}
.header_nav_li .link::after{
  content: "";
  width: 100%;
  height: 3px;
  background: rgba(255,255,255,0);
  position: absolute;
  left: 0;
  bottom: 0;
}
.header_nav_li .link:hover {
  color: rgba(180,39,45,1);
}
.header_nav_li .link:hover::after {
  background: rgba(180,39,45,1);
}
.header_nav_li.active .link{
  color: rgba(180,39,45,1);
}
.header_nav_li.active .link::after{
  background: rgba(180,39,45,1);
}
</style>